import {
  DataOnboardingState,
  DataOnboardingActionTypes,
  FETCH_ONESCHEMA_TOKEN_REQUEST,
  FETCH_ONESCHEMA_TOKEN_SUCCESS,
  FETCH_ONESCHEMA_TOKEN_FAILURE,
} from './types';

const initialState: DataOnboardingState = {
  oneSchemaToken: null,
  loadingOneSchemaToken: false,
  oneSchemaTokenError: null,
};

export const dataOnboardingReducer = (
  state = initialState,
  action: DataOnboardingActionTypes
): DataOnboardingState => {
  switch (action.type) {
    case FETCH_ONESCHEMA_TOKEN_REQUEST:
      return {
        ...state,
        loadingOneSchemaToken: true,
        oneSchemaTokenError: null,
      };
    case FETCH_ONESCHEMA_TOKEN_SUCCESS:
      return {
        ...state,
        loadingOneSchemaToken: false,
        oneSchemaToken: action.payload,
        oneSchemaTokenError: null,
      };
    case FETCH_ONESCHEMA_TOKEN_FAILURE:
      return {
        ...state,
        loadingOneSchemaToken: false,
        oneSchemaTokenError: action.payload,
        oneSchemaToken: null, // Clear token on failure
      };
    default:
      return state;
  }
};

export default dataOnboardingReducer; // Default export for combining reducers easily
